// Video Popup Native Support
// Extends the existing popup functionality to support HTML5 native videos

(function() {
  'use strict';

  // Store references to native HTML5 videos
  window.listNativeVideoPopup = [];

  // Initialize native video support
  function initNativeVideoSupport() {
    // Wait for the popup functionality to be loaded
    if (typeof window.listVideoPopup === 'undefined') {
      setTimeout(initNativeVideoSupport, 100);
      return;
    }

    setupNativeVideos();
    extendPopupFunctionality();
  }

  // Setup native HTML5 videos
  function setupNativeVideos() {
    window.listNativeVideoPopup = [];
    
    $('.gallary-item').each(function(i, el) {
      var $videoElement = $(el).find('video.video-popup');
      
      if ($videoElement.length) {
        window.listNativeVideoPopup.push($videoElement[0]);
      } else {
        window.listNativeVideoPopup.push(null);
      }
    });
  }

  // Extend existing popup functionality
  function extendPopupFunctionality() {
    // Store original openVideo function if it exists
    var originalOpenVideo = null;
    
    // Try to get the Popup class instance
    if (typeof Popup !== 'undefined') {
      var popupInstance = new Popup();
      if (popupInstance.openVideo) {
        originalOpenVideo = popupInstance.openVideo.bind(popupInstance);
      }
    }

    // Override openVideo function globally
    window.openVideoWithNative = function(nb) {
      // Call original function for YouTube/Vimeo videos
      if (originalOpenVideo) {
        originalOpenVideo(nb);
      } else if (window.listVideoPopup && window.listVideoPopup.length) {
        window.listVideoPopup.forEach(function(elem, i) {
          if (nb === i) {
            if (window.listVideoPopup[nb] !== '') {
              if (typeof window.listVideoPopup[nb].origin === 'undefined') {
                window.listVideoPopup[nb].seekTo(0);
                window.listVideoPopup[nb].playVideo();
              } else {
                window.listVideoPopup[nb].setCurrentTime(0);
                window.listVideoPopup[nb].play();
              }
            }
          } else {
            if (window.listVideoPopup[i] !== '') {
              if (typeof window.listVideoPopup[i].origin === 'undefined') {
                window.listVideoPopup[i].pauseVideo();
              } else {
                window.listVideoPopup[i].pause();
              }
            }
          }
        });
      }

      // Handle native HTML5 videos
      if (window.listNativeVideoPopup && window.listNativeVideoPopup.length) {
        window.listNativeVideoPopup.forEach(function(video, i) {
          if (video) {
            if (nb === i) {
              // Play the current video
              video.currentTime = 0;
              video.play().catch(function(error) {
                console.log('Video autoplay prevented:', error);
              });
            } else {
              // Pause other videos
              video.pause();
            }
          }
        });
      }
    };

    // Override closeVideo function
    window.closeAllVideos = function() {
      // Pause all native videos
      if (window.listNativeVideoPopup && window.listNativeVideoPopup.length) {
        window.listNativeVideoPopup.forEach(function(video) {
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });
      }

      // Pause YouTube/Vimeo videos
      if (window.listVideoPopup && window.listVideoPopup.length) {
        window.listVideoPopup.forEach(function(player) {
          if (player !== '') {
            if (typeof player.origin === 'undefined') {
              player.pauseVideo();
            } else {
              player.pause();
            }
          }
        });
      }
    };
  }

  // Hook into gallery slider events
  function hookIntoGalleryEvents() {
    $(document).on('click', '.popup-is-open[data-popup="garally"]', function() {
      setTimeout(function() {
        setupNativeVideos();
        
        // Start the first video when gallery opens
        var currentSlide = $('.gallary-item.slick-current').attr('data-slick-index');
        if (currentSlide !== undefined) {
          window.openVideoWithNative(parseInt(currentSlide));
        }
      }, 500);
    });

    // Handle slide changes
    $(document).on('afterChange', '.gallary-silder', function(event, slick, currentSlide) {
      if ($(window).width() >= 1200) {
        window.openVideoWithNative(currentSlide);
      }
    });

    // Handle popup close
    $(document).on('click', '.popup-is-close', function() {
      window.closeAllVideos();
    });

    // Handle escape key and overlay click
    $(document).on('keydown', function(e) {
      if (e.keyCode === 27 && $('.popup-show').length) {
        window.closeAllVideos();
      }
    });

    $(document).on('click', '.mask-pop-overlay', function() {
      window.closeAllVideos();
    });
  }

  // Initialize when DOM is ready
  $(document).ready(function() {
    initNativeVideoSupport();
    hookIntoGalleryEvents();
  });

})(); 